import { render } from "./chevron-up.svg?vue&type=template&id=7d6fb517"
const script = {}
script.render = render

export default script